// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:45:40

export default {
  "id": "hidden-mushrooms",
  "slug": "hidden-mushrooms",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ec362da670b04a048012a41f913e30c6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ec362da670b04a048012a41f913e30c6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hidden Mushrooms",
      "description": "Hidden Mushrooms is a game for nature lovers and those who enjoy walking in the woods. Beautiful views of nature in different forests, fields, swamps and other places. Birds singing and cute animals help you relax, and the search for hidden mushrooms captures your attention.\nYou will spend time usefully, because the game perfectly trains your observation skills!\nDo you like hidden object searches? Then be sure to try to find hidden mushrooms!",
      "instructions": "Each level has a new forest with its own type of mushroom. Use your keen eye and attention to spot the hidden mushrooms.\nWhen you spot a mushroom, tap on it to collect it. Collect mushrooms and unlock new levels. The menu shows the number of mushrooms needed to unlock each level. The first forest is available right away.\nWatch the mushroom counter in the menu to track your progress.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3d",
        "forest",
        "hidden",
        "relaxing"
      ]
    },
    "zh-CN": {
      "title": "隐藏蘑菇",
      "description": "《隐秘蘑菇》是一款适合自然爱好者和喜欢在树林中散步的人的游戏。游戏中展示了不同森林、田野、沼泽等地自然美景。鸟儿的歌唱和可爱的小动物帮助你放松，而寻找隐藏的蘑菇则吸引你的注意力。\n你将度过有意义的时光，因为这款游戏完美地训练了你的观察力！\n你喜欢隐藏物品搜索吗？那么一定要尝试寻找隐藏的蘑菇！",
      "instructions": "每个关卡都有一种新的森林，以及其特有的蘑菇。用你敏锐的眼睛和注意力来发现隐藏的蘑菇。\n当你发现蘑菇时，点击它来收集。收集蘑菇可以解锁新关卡。菜单显示了解锁每个关卡所需的蘑菇数量。第一个森林立即可用。\n在菜单中查看蘑菇计数器，以追踪你的进度。",
      "genres": [
        "模拟"
      ],
      "tags": [
        "三维",
        "森林",
        "隐藏",
        "放松"
      ]
    },
    "zh-TW": {
      "title": "隱藏的蘑菇",
      "description": "隱藏蘑菇是一款適合愛自然及喜歡在森林中散步的人們的遊戲。遊戲中展示了不同森林、田地、濕地等各種自然美景。鳥鳴聲和可愛的動物能幫助你放鬆，尋找隱藏蘑菇則能吸引你的注意力。\n你將會花費時間在有益的事上，因為這款遊戲能完美地鍛鍊你的觀察力！\n你喜歡尋找隱藏物品的遊戲嗎？那麼請一定要試試尋找隱藏蘑菇！",
      "instructions": "每關都有全新的森林，擁有自己類型的蘑菇。用你敏銳的眼睛和注意力尋找隱藏的蘑菇。\n當你發現蘑菇時，點擊它來收集。收集蘑菇以解鎖新關卡。菜單顯示了解鎖每關所需的蘑菇數量。第一個森林立即可用。\n觀察菜單中的蘑菇計數器以跟蹤你的進度。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "森林",
        "隱藏",
        "放鬆"
      ]
    },
    "zh-HK": {
      "title": "隱藏蘑菇",
      "description": "隱藏蘑菇是一款適合喜愛自然和欣賞森林散步的人們的遊戲。遊戲中有不同森林、田野、濕地等地的美麗自然景觀。鳥鳴聲聲和可愛的動物讓你放鬆，尋找隱藏蘑菇則能吸引你的注意力。\n你將會在遊戲中過得有價值，因為這款遊戲能完美培養你的觀察力！\n你喜歡尋找隱藏物件的遊戲嗎？那麼千萬不要錯過試玩尋找隱藏蘑菇！",
      "instructions": "每個級別都有一個新森林，擁有自己的蘑菇種類。用你靈敏的眼睛和注意力去發現隱藏的蘑菇。\n當你發現蘑菇時，點擊它來收集。收集蘑菇以解鎖新級別。菜單會顯示解鎖每個級別所需的蘑菇數量。第一個森林立即可使用。\n觀察菜單中的蘑菇計數器以跟蹤你的進度。",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "森林",
        "隱藏",
        "放鬆"
      ]
    },
    "ja": {
      "title": "隠れキノコ",
      "description": "隠れキノコは、自然を愛する人や森を散策を楽しむ人々向けのゲームです。様々な森、草原、湿地などの自然の美しい景色。鳥のさえずりや可愛い動物がリラックスさせてくれる、そして隠れたキノコを探すことであなたの注意を引き付けることができます。\n\n有効に時間を使うことができます、なぜなら、このゲームは観察力を完璧に鍛えるためのものだからです！\n\n隠れたオブジェクトの探し出しを好きですか？それとも隠れたキノコを探してみる価値があります！",
      "instructions": "各レベルには、それぞれの種類のキノコを持つ新しい森があります。鋭い目と注意を払って、隠されたキノコを見つけましょう。\nキノコを見つけたら、それをタップして収集してください。キノコを収集すると、新しいレベルを解禁できます。メニューには、各レベルを解禁するために必要なキノコの数が表示されています。最初の森はすぐに利用可能です。\nメニューのキノコカウンタを確認して、進捗を追ってください。",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "森",
        "隠れ",
        "リラックス"
      ]
    },
    "ko": {
      "title": "숨겨진 버섯",
      "description": "Hidden Mushrooms는 자연 사랑자와 산책을 좋아하는 사람들을 위한 게임입니다. 다양한 숲, 들판, 습지 등의 자연 경관을 만끽할 수 있습니다. 새들의 노래와 귀여운 동물들이 여러분을 편안하게 만들고, 숨겨진 귤의 탐색이 여러분의 관심을 끕니다.\n 게임을 통해 유익한 시간을 보내실 수 있습니다. 왜냐하면 이 게임은 여러분의 관찰력을 완벽하게 훈련시킨다는 것입니다!\n 숨겨진 물건 찾기 게임을 좋아하시나요? 그렇다면 숨겨진 귤을 찾아보세요!",
      "instructions": "각 단계마다 독특한 종류의 버섯을 가진 새로운 숲이 있습니다. 신비로운 버섯을 찾기 위해 예리한 눈과 주의력을 사용하세요.\n버섯을 발견하면 터치하여 수집하세요. 버섯을 수집하여 새로운 단계를 해금하세요. 메뉴는 각 단계를 해금하기 위해 필요한 버섯의 수를 보여줍니다. 첫 번째 숲은 즉시 사용할 수 있습니다.\n메뉴의 버섯 카운터를 통해 진행 상황을 추적하세요.",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "숲",
        "숨겨져 있음",
        "편안함"
      ]
    },
    "fr": {
      "title": "Fonges cachés",
      "description": "Les Champignons Cachés est un jeu pour les amoureux de la nature et ceux qui aiment se promener dans les bois. Belles vues de la nature dans différents forêts, champs, marais et autres endroits. Oiseaux chantant et animaux mignons vous aident à vous détendre, et la recherche de champignons cachés capte votre attention.\nVous passerez du temps utilement, car le jeu entraîne parfaitement vos compétences d'observation !\nAimez-vous les recherches d'objets cachés ? Alors n'hésitez pas à essayer de trouver les champignons cachés !",
      "instructions": "Chaque niveau comporte une nouvelle forêt avec son propre type de champignon. Utilisez votre regard aigu et votre attention pour repérer les champignons cachés.\nQuand vous voyez un champignon, appuyez dessus pour le ramasser. Ramassez des champignons et débloquez de nouveaux niveaux. Le menu indique le nombre de champignons nécessaires pour débloquer chaque niveau. La première forêt est disponible dès le départ.\nSurveillez le compteur de champignons dans le menu pour suivre votre progression.",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3D",
        "forêt",
        "caché",
        "apaisant"
      ]
    }
  }
};
